import React from "react";
import { Icons } from "../../components/common/Icons";

function EmpModal({ title, onClose, children }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <div className="modal-close" onClick={onClose}><Icons.Close /></div>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

export default EmpModal;
